<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Testimonial Website</h5>
            <div class="tabel-action mb-4">
                <button type="button" v-b-modal.modal-Testimonial class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Testimonial</button>
            </div>

            <draggable
                v-bind="dragOptions"
                v-model="testimonial"
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(data,index) in testimonial" :key="data.id" class="link mb-3">
                        <div class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.name}}</strong></div>
                                </div>
                                <div class="link-switch d-flex align-items-center">
                                    <a href="#" v-b-modal.modal-Testimonial v-on:click.prevent="ASSIGN_FORM_TESTIMONIAL(data)" class="act mb-0">
                                        <i class="uil uil-pen"></i>
                                        <span class="link-tx"> Edit</span>
                                    </a>
                                    <a href="#" v-on:click.prevent="alertDelete(data.id,index)" class="act mb-0">
                                        <i class="uil uil-trash-alt"></i>
                                        <span class="link-tx"> Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </transition-group>

            </draggable>
        </div>

        <b-modal id="modal-Testimonial" size="lg" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_TESTIMONIAL">

            <ValidationObserver ref="form">
                <div class="row">
                    
                      <div class="col-md-12">
                        <validation-provider v-if="!formtestimonial.photo" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                            <div class="form-group">
                                <div class="mb-1">
                                    <label>Client Photo</label>
                                </div>
                                <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                                    <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                </div>
                                <input ref="inputImage" 
                                        type="file"
                                        class="custom-file-input d-none"
                                        id="Thumbnail"
                                        v-on:change="onImageUpload"
                                        accept="image/jpeg,image/png,image/jpg" 
                                        @input="validate" >
            
                            </div>
                        </validation-provider>
                        
                        <div class="form-group" v-if="formtestimonial.photo">   
                            <div class="mb-1">
                                <label>Client Photo</label>
                            </div> 
                            <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                            <div class="input-group img-sh">
                                <img :src="formtestimonial.photo" class="img-responsive img-prf">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                         <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Client Name</label>
                                <input v-model="formtestimonial.name" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                         <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Client Job & City</label>
                                <input v-model="formtestimonial.job" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-12">
                         <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Title Testimonial</label>
                                <input v-model="formtestimonial.title" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-12">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Description Testimonial</label>
                                <textarea class="form-control" v-model="formtestimonial.desc"></textarea>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>

                </div>

                <div class="text-right mt-4">
                    <button v-on:click="validationForm(formtestimonial.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Testimonial
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                loading:false,
                photo_file:'',
                modal_title : 'Add Testimonial',
            }
        },
        watch:{
            'formtestimonial':function(val){
                if(val.id){
                    this.modal_title = 'Edit Testimonial'
                }else if(!val.id){
                    this.modal_title = "Add Testimonial"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed:{
            ...mapState('WebsiteControl', {
                website: state => state.website,
                formtestimonial: state => state.formtestimonial
            }),

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            testimonial: {
                get() {
                    return this.website.testimonial
                },
                set(value) {
                    this.SET_POSITION_TESTIMONIAL(value)
                    this.updatePositionTestimonial(value)
                }
            }
        },
        methods:{
            ...mapMutations('WebsiteControl', ['SET_POSITION_TESTIMONIAL','CLEAR_FORM_TESTIMONIAL','ASSIGN_FORM_TESTIMONIAL']),
            ...mapActions('WebsiteControl', ['getWebsite','createTestimonial','updateTestimonial','deleteTestimonial','updatePositionTestimonial']),
            
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formtestimonial.photo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.photo_file = ''
                this.formtestimonial.photo = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('name', this.formtestimonial.name);
                        formData.append('job', this.formtestimonial.job);
                        formData.append('title', this.formtestimonial.title);
                        formData.append('desc', this.formtestimonial.desc);
                        formData.append('photo', this.formtestimonial.photo ? this.formtestimonial.photo : '');
                        formData.append('photo_file', this.photo_file);

                        if(id){
                            formData.append("_method", "put");
                            this.updateTestimonial(formData).then(() => {
                                this.loading = false
                                this.photo_file = ''
                                this.$bvModal.hide('modal-Testimonial')
                                this.getWebsite(this.$route.params.id)
                                this.$toast.success('Successfully Update Testimonial')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createTestimonial(formData).then(() => {
                                this.loading = false
                                this.photo_file = ''
                                this.$bvModal.hide('modal-Testimonial')
                                this.getWebsite(this.$route.params.id)
                                this.$toast.success('Successfully Added Testimonial')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                });
            },
            alertDelete:function(id,index){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this testimonial data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteTestimonial(id).then(
                            this.$toast.success('Successfully Deleting Testimonial'),
                            this.website.testimonial.splice(index, 1)
                        ).catch((error) => {
                            console.log(error)
                            this.$toast.warning('Sorry, Something Error')
                        })
                    }
                })
            },
        }
    }

</script>

<style scoped>
    .img-sh img{
        width: 190px;
    }
    .link-icon img,
    .link-icon .no-img{
        width: 60px;
        height: 60px;
    }
    .btn-outline-secondary.qr{
        width: 100px;
        height: 100px;
    }
    .category-themes .btn-outline-secondary.qr:nth-child(3) img{
        width: 45px !important;
    }
    .btn-outline-secondary{
        border-color: #e4e6fc;
    }
    .btn-outline-secondary.active,
    .btn-outline-secondary:hover {
        background: #e4e6fc !important;
        border-color: #e4e6fc !important;
    }

</style>
